import React from 'react';
import Day from './Day';

const Week = ({daysInWeek, weekNum, monthName, history, match, monthData}) => {

    return (
        <div className="weekWrap">
            {
                daysInWeek.map((dayData, index) => (
                    <Day 
                        key={`week${weekNum}day${index + 1}`} 
                        dayData={dayData} 
                        monthName={monthName} 
                        history={history}
                        match={match}
                        monthData={monthData}
                    />
                ))
            }
        </div>
    )
}

export default Week;